<template>
  <div>
    <Navbar ref="navbarRef" :selectedOption="1" />
    <h4></h4>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td>
            <input
              type="text"
              class="form-control"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              style="width: 500px; text-transform: uppercase"
              required
            />
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPagina(1)"
              title="Buscar registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >search</i
              >
              Buscar
            </button>
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i
              >
            </button>
          </td>
          <td>
            <button
              type="submit"
              class="btn btn-light"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModal"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i
              >
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Cantidad</th>
          <th scope="col">Descripcion</th>
          <th scope="col">FechaAtencion</th>
          <th scope="col">ValorUni</th>
          <th scope="col">Codigo</th>
          <th scope="col">ElementoNombre</th>
          <th scope="col">CargaPlanillaNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="cargaplanilladet in datosPaginados"
          :key="cargaplanilladet.idCargaPlanillaDet"
        >
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(cargaplanilladet.idCargaPlanillaDet)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(cargaplanilladet.idCargaPlanillaDet)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ cargaplanilladet.cantidad }}</td>
          <td>{{ cargaplanilladet.descripcion }}</td>
          <td>
            {{ getFormattedDate(cargaplanilladet.fechaAtencion, "DD/MM/YYYY") }}
          </td>
          <td>{{ cargaplanilladet.valorUni }}</td>
          <td>{{ cargaplanilladet.codigo }}</td>
          <td>{{ cargaplanilladet.elementoNombre }}</td>
          <td>{{ cargaplanilladet.cargaPlanillaNombre }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="
                deleteCargaPlanillaDet(cargaplanilladet.idCargaPlanillaDet)
              "
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idCargaPlanillaDet" class="form-label"
                      >IdCargaPlanillaDet</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idCargaPlanillaDet"
                      name="idCargaPlanillaDet"
                      v-model="datoCargaPlanillaDet.idCargaPlanillaDet"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="cantidad" class="form-label">Cantidad</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="cantidad"
                      name="cantidad"
                      v-model="datoCargaPlanillaDet.cantidad"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="descripcion" class="form-label"
                      >Descripcion</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="descripcion"
                      name="descripcion"
                      v-model="datoCargaPlanillaDet.descripcion"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaAtencion" class="form-label"
                      >FechaAtencion</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaAtencion"
                      name="fechaAtencion"
                      v-model="datoCargaPlanillaDet.fechaAtencion"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="valorUni" class="form-label">ValorUni</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="valorUni"
                      name="valorUni"
                      v-model="datoCargaPlanillaDet.valorUni"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Carga Planilla -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idCargaPlanilla" class="form-label">
                      Carga Planilla</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idCargaPlanilla"
                      name="idCargaPlanilla"
                      v-model="datoCargaPlanillaDet.idCargaPlanilla"
                    >
                      <option
                        v-for="cargaPlanilla in cargaPlanillas"
                        :value="cargaPlanilla.idCargaPlanilla"
                        :key="cargaPlanilla.idCargaPlanilla"
                      >
                        {{ cargaPlanilla.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Carga Planilla -->
              <!-- Botón Lista de Valores  Elemento -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idElemento"
                      name="idElemento"
                      v-model="datoCargaPlanillaDet.idElemento"
                    >
                      <option
                        v-for="elemento in elementos"
                        :value="elemento.idElemento"
                        :key="elemento.idElemento"
                      >
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Elemento -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="codigo" class="form-label">Codigo</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="codigo"
                      name="codigo"
                      v-model="datoCargaPlanillaDet.codigo"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <div class="me-auto">
              <button
                type="button"
                id="send"
                class="btn btn-light"
                data-bs-dismiss="modal"
                title="Cerrar"
              >
                <i
                  class="material-icons"
                  style="font-size: 32px; color: orangered; cursor: pointer"
                  >meeting_room</i
                >
              </button>
            </div>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarCargaPlanillaDet"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarEditCargaPlanillaDet"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Navbar from "../../components/Navbar.vue";
import Footer from "../../components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "../../modules/dateFormat.js";
import { format } from "date-fns";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      cargaplanilladets: [],
      datoCargaPlanillaDet: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      cargaPlanillas: [],
      elementos: [],
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, "dd/MM/yyyy");
    },
  },

  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.navbarRef.toggleProcesos();
    this.$refs.navbarRef.toggleReportes();
    this.$refs.navbarRef.toggleParametros();
    this.$refs.navbarRef.toggleAyuda();
    this.fetchCargaPlanillas();
    this.fetchElementos();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.cargaplanilladets.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwcargaplanilladets/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.cargaplanilladets = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.cargaplanilladets.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwcargaplanilladets")
        .then((response) => {
          this.cargaplanilladets = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.cargaplanilladets.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "cantidad",
        "descripcion",
        "fechaAtencion",
        "valorUni",
        "idCargaPlanilla",
        "idElemento",
        "codigo",
      ];
      const requiredFieldsText = [
        "cantidad",
        "descripcion",
        "fechaAtencion",
        "valorUni",
        "idCargaPlanilla",
        "idElemento",
        "codigo",
      ];
      return validarForm(
        this.datoCargaPlanillaDet,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarCargaPlanillaDet() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/cargaplanilladets",
            this.datoCargaPlanillaDet
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "CargaPlanillaDet creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditCargaPlanillaDet() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/cargaplanilladets",
            this.datoCargaPlanillaDet
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal(
            "Correcto!",
            "CargaPlanillaDet creado(a) exitosamente!",
            "success"
          );
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoCargaPlanillaDet = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idCargaPlanillaDet) {
      this.modalWindow = true;
      if (idCargaPlanillaDet != null) {
        api.get("/vwcargaplanilladets/" +
              idCargaPlanillaDet
          )
          .then((resp) => {
            this.datoCargaPlanillaDet = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idCargaPlanillaDet) {
      if (idCargaPlanillaDet != null) {
        this.$router.push("/cargaplanilladetmd/" + idCargaPlanillaDet);
      }
    },
    async deleteCargaPlanillaDet(idCargaPlanillaDet) {
      try {
        await api.delete("/cargaplanilladets/" + idCargaPlanillaDet
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchCargaPlanillas() {
      fetch(config.apiBaseUrl + "/cargaplanillas")
        .then((response) => response.json())
        .then((data) => {
          this.cargaPlanillas = data;
        })
        .catch((error) => {
          console.error("Error fetching cargaPlanillas:", error);
        });
    },
    fetchElementos() {
      fetch(config.apiBaseUrl + "/elementos")
        .then((response) => response.json())
        .then((data) => {
          this.elementos = data;
        })
        .catch((error) => {
          console.error("Error fetching elementos:", error);
        });
    },
  },
};
</script>
